
import { createI18n } from "vue-i18n";
import axios from "axios";

let loadedLanguages = [];
let loadedLanguagesRefs = {};

export const i18n = createI18n({
    locale: "en-gb",
    fallbackLocale: "en-gb"
});

function setI18nLanguage(languageId) {
    i18n.global.locale = languageId;
    document.querySelector("html").setAttribute("lang", languageId);
    return loadedLanguages[loadedLanguagesRefs[languageId]];
}

function hasLoadedLanguage(lang) {
    return Object.prototype.hasOwnProperty.call(loadedLanguagesRefs, lang);
}
function getLoadedLanguage(lang) {
    if (!hasLoadedLanguage(lang)) {
        return false;
    }
    return loadedLanguages[loadedLanguagesRefs[lang]];
}
function setLoadedLanguage(languageObj) {
    const index = loadedLanguages.push(languageObj);
    loadedLanguagesRefs[languageObj.j2e_code] = index - 1;
    loadedLanguagesRefs[languageObj.id] = index - 1;
}

export function loadLanguageAsync(lang) {
    // Language was already loaded
    let languageObj = getLoadedLanguage(lang); //Get full language object
    if (languageObj !== false) {
        return Promise.resolve(setI18nLanguage(languageObj.id));
    }

    let langHash = window.langHash || 0;

    // If the language hasn't been loaded yet
    return axios
        .get(
            `${import.meta.env.VITE_I18N_DOMAIN}/lang/${lang}.json?v=${langHash}`
        )
        .then(response => {
            i18n.global.setLocaleMessage(
                response.data.language.id,
                response.data.translations
            );
            setLoadedLanguage(response.data.language);
            return setI18nLanguage(response.data.language.id);
        })
        .catch(err => {
            console.log("failed to load language");
            console.log(err);
            i18n.global.setLocaleMessage("en-gb", {});
            setLoadedLanguage({
                id: "en-gb",
                name: "English (GB)",
                native_name: "",
                j2e_code: "english",
                supported: true,
                iso_639_1: null,
                iso_639_2_t: null,
                iso_639_2_b: null,
                iso_639_3: null
            });
            return setI18nLanguage("en-gb");
        });
}
